module.exports = __webpack_public_path__ + "img/header-dots.9fa4a89c.svg";